import { Box, Stack, Typography } from '@mui/material';

import { ERROR_TEXT_SX, ErrorPage, ErrorPageAction } from "../components/errors/ErrorPage";
import { takeUnavailableFrom } from "../api/utils";

const PROMISES = [ 'Your answers and progress are saved', 'Recaps keep their due dates' ];

/** Shown when the backend answers that it cannot serve right now; trying again returns to the page the user was on. */
export default function Page503() {
    function handleRetry() {
        window.location.assign(takeUnavailableFrom() ?? '/dashboard');
    }

    return (
        <ErrorPage code={ 503 } title="We are tuning the engine" tabTitle="Service Unavailable"
                   illustration={ { src: '/assets/images/illustrations/unavailable.svg', alt: 'Robots repairing a server rack' } }>
            <Typography sx={ ERROR_TEXT_SX }>KataQuiz is down for a short update. Please try again in a few minutes.</Typography>

            <Stack component="ul" spacing={ 1.25 } sx={ { listStyle: 'none', m: 0, p: 0, fontSize: 15 } }>
                { PROMISES.map((promise) => (
                    <Stack key={ promise } component="li" direction="row" spacing={ 1.25 } alignItems="center">
                        <Box aria-hidden="true" sx={ {
                            width: 22, height: 22, borderRadius: '11px', bgcolor: '#229A16', color: '#FFFFFF', flexShrink: 0,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        } }>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12l5 5 9-10"/>
                            </svg>
                        </Box>
                        <span>{ promise }</span>
                    </Stack>
                )) }
            </Stack>

            <Stack direction="row" spacing={ 1.5 } sx={ { pt: 0.5 } }>
                <ErrorPageAction onClick={ handleRetry } primary>Try again</ErrorPageAction>
            </Stack>
        </ErrorPage>
    );
}
